import BlogPostContainer from "./BlogPostContainer";

const Schottland = () => {
    const blogPosts = [
        {
            date: "28.06.2025",
            title: "10. Tag",
            content: (
                <>
                    Hallo zusammen,
                    <br/><br/>
                    heute fuhren wir noch gemütlich durch den Galloway Forest Park, bevor wir uns direkt auf den Weg zur Fähre machten.
                    <br/><br/>
                    Nach knapp zweieinhalb Stunden Wartezeit konnten wir schließlich an Bord gehen – und damit heißt es
                    Abschied nehmen von dieser wunderschönen Reise.
                    <br/><br/>
                    Und damit verabschieden wir uns von dieser Reise. Morgen steht noch die Fahrt nach hause an.
                    <br/><br/>
                    Bis zum nächsten Mal,<br/>
                    Eure HeimReiser
                </>
            ),
            images: [

            ]
        },
        {
            date: "27.06.2025",
            title: "9. Tag",
            content: (
                <>
                    Guten Abend und herzlich Willkommen zu unserem letzten Abend in Schottland,
                    <br/><br/>
                    Den heutigen Tag starteten wir mit der Fahrt über den Three Lochs Forest Drive – eine landschaftlich
                    schöne Rundstrecke, die allerdings weniger spektakulär war, als wir erhofft hatten.
                    <br/><br/>
                    Da wir den weiteren Tagesverlauf ohne festen Plan angingen, wurde es ein etwas längerer Fahrtag.
                    Nach dem Loch Lomond zog es uns zunächst an die Küste und anschließend wieder etwas ins Landesinnere – bis in den Galloway Forest Park.
                    <br/><br/>
                    Morgen steht noch eine gemütliche Fahrt durch den Forest Park auf dem Programm, bevor wir uns auf
                    den Weg zur Fähre machen. Wir melden uns dann sicher noch ein letztes Mal, bevor diese schöne Reise zu Ende geht.
                    <br/><br/>
                    Heute mal wieder ein Relive-Video unserer Route:
                    <a href="https://www.relive.com/view/v1vjPX9DNY6"> zur Videoroute</a>
                    <br/><br/>
                    Bis morgen,<br/>
                    Eure VWBusFahrer
                </>
            ),
            images: [
                "/images/09_Schottland/9.1.jpeg",
                "/images/09_Schottland/9.2.jpeg",
            ]
        },
        {
            date: "26.06.2025",
            title: "8. Tag",
            content: (
                <>
                    Hallihallo zusammen,
                    <br/><br/>
                    Heute ging es früh los in Richtung Glenfinnan Viadukt – berühmt durch die Dampflok-Szene aus Harry Potter.
                    Zusammen mit zahlreichen anderen Touris/Fans warteten wir gespannt auf den Zug – ein kleines Highlight für alle Potterheads!
                    <br/><br/>
                    Anschließend fuhren wir weiter in Richtung Loch Lomond. Unterwegs durchquerten wir das
                    Tal von Glencoe, das nicht nur landschaftlich beeindruckt, sondern auch als Drehort für einige James Bond Szenen aus Skyfall diente.
                    <br/><br/>
                    Nun genießen wir den Rest des Nachmittags und Abends in aller Ruhe. Für morgen steht der Three Lochs
                    Forest Drive auf dem Plan – und wenn die Zeit es erlaubt, vielleicht noch ein kurzer Abstecher nach Glasgow.
                    <br/><br/>
                    Wir wünschen einen schönen Abend,<br/>
                    Eure HarryPotterFans
                </>
            ),
            images: [
                "/images/09_Schottland/8.1.jpg",
                "/images/09_Schottland/8.2.jpeg",
                "/images/09_Schottland/8.3.jpeg",
                "/images/09_Schottland/8.4.jpeg",
            ]
        },
        {
            date: "25.06.2025",
            title: "7. Tag",
            content: (
                <>
                    Guten Abend,
                    <br/><br/>
                    Heute stand die Erkundung der Isle of Skye auf dem Programm. Unser erster Halt war beim Creag an
                    Fhèilidh – ein beeindruckender Wasserfall, der direkt von der Klippe ins Meer stürzt.
                    <br/><br/>
                    Anschließend ging es weiter zu den mystischen Fairy Glen – eine zauberhafte Landschaft mit
                    Hügeln und Feensteinkreise. Dort unternahmen wir einen gemütlichen Spaziergang und ließen die
                    besondere Atmosphäre auf uns wirken.
                    <br/><br/>
                    Danach setzten wir unsere Rundfahrt gegen den Uhrzeigersinn fort und genossen – wie schon die letzten
                    Tage in Schottland – die traumhafte Landschaft von Skye. Ein kurzer Abstecher ins charmante
                    Städtchen Portree durfte dabei natürlich nicht fehlen. Auf dem Weg legten wir zudem einen kurzen Stopp
                    beim eindrucksvollen Eilean Donan Castle ein.
                    <br/><br/>
                    Inzwischen haben wir die Isle of Skye wieder verlassen und stehen für die Nacht an einem schönen, ruhigen Plätzchen.
                    <br/><br/>
                    Bis morgen,<br/>
                    Eure SkyeEntdecker
                </>
            ),
            images: [
                "/images/09_Schottland/7.1.jpeg",
                "/images/09_Schottland/7.2.jpg",
                "/images/09_Schottland/7.3.jpg",
                "/images/09_Schottland/7.4.jpg",
                "/images/09_Schottland/7.5.jpeg",
                "/images/09_Schottland/7.6.jpg",
                "/images/09_Schottland/7.7.jpg",
            ]
        },
        {
            date: "24.06.2025",
            title: "6. Tag",
            content: (
                <>
                    Da sich das Wetter nicht wirklich gebessert hat und es immer wieder geregnet hat, stand heute ein
                    Fahrtag mit nur wenigen Pausen auf dem Programm.
                    <br/><br/>
                    Am Morgen haben wir einen Spaziergang durch das Corrieshalloch Gorge National Nature Reserve gemacht.
                    <br/><br/>
                    Anschließend fuhren wir weiter entlang der NC500 in Richtung Isle of Skye. Auch heute begleiteten
                    uns wieder spektakuläre Buchten und beeindruckende Landschaften. Und endlich: Unsere ersten drei Highland Cows!
                    <br/><br/>
                    Unsere Route führte uns auch über den berühmten Applecross Pass, doch leider lag der gesamte Pass
                    im Nebel, sodass uns die Aussicht verwehrt blieb.
                    <br/><br/>
                    Inzwischen sitzen wir auf einem Campingplatz im Nordosten der Isle of Skye, von wo aus wir morgen die Insel erkunden werden.
                    <br/><br/>
                    Heutiges Etappenvideo:
                    <a href="https://www.relive.com/view/vE6J5VBBKgO"> zur Videoroute</a>
                    <br/><br/>
                    Wir lesen uns morgen wieder,<br/>
                    Eure NebelPassFahrer
                </>
            ),
            images: [
                "/images/09_Schottland/6.1.jpg",
                "/images/09_Schottland/6.2.jpg",
                "/images/09_Schottland/6.3.jpg",
                "/images/09_Schottland/6.4.jpeg",
                "/images/09_Schottland/6.5.jpeg",
                "/images/09_Schottland/6.6.jpeg",
                "/images/09_Schottland/6.7.jpeg",
                "/images/09_Schottland/6.8.jpeg",
                "/images/09_Schottland/6.9.jpeg",
                "/images/09_Schottland/6.10.jpeg",
                "/images/09_Schottland/6.11.jpeg",
                "/images/09_Schottland/6.12.jpeg",
            ]
        },
        {
            date: "23.06.2025",
            title: "5. Tag",
            content: (
                <>
                    Guten Abend
                    <br/><br/>
                    Nach einer regnerischen und sehr windigen Nacht setzten wir unsere Fahrt entlang der NC500 fort.
                    <br/><br/>
                    Leider hat der Wind nicht nachgelassen, sodass unser geplanter Ausflug zur Insel Handa – auf der wir
                    eigentlich nach Puffins Ausschau halten wollten – buchstäblich ins Wasser gefallen ist.
                    <br/><br/>
                    Stattdessen ging es weiter der Küste entlang, stets der NC500 folgend. Unterwegs haben wir schöne Buchten bestaunt und
                    die beeindruckende Strasse genossen.
                    <br/><br/>
                    Die nächste Etappe als Video:
                    <a href="https://www.relive.com/view/v1vjPWrZ4Y6"> zur Videoroute</a>
                    <br/><br/>
                    Viel mehr gibt es heute nicht zu berichten – wir stehen nun an unserem Übernachtungsplatz,
                    der Wind hat noch nicht abgenommen und mittlerweile regnet es auch schon wieder. Mal sehen was uns morgen erwartet.
                    <br/><br/>
                    Bis dann,<br/>
                    Eure KurvenFahrer
                </>
            ),
            images: [
                "/images/09_Schottland/5.1.jpeg",
                "/images/09_Schottland/5.2.jpeg",
                "/images/09_Schottland/5.3.jpeg",
                "/images/09_Schottland/5.5.jpg",
                "/images/09_Schottland/5.6.jpg",
                "/images/09_Schottland/5.7.jpeg",
                "/images/09_Schottland/5.8.jpeg",
                "/images/09_Schottland/5.9.jpg",
            ]
        },
        {
            date: "22.06.2025",
            title: "4. Tag",
            content: (
                <>
                    Hallo und herzlich willkommen zu einer neuen Folge: „Was ist heute passiert?“
                    <br/><br/>
                    Nach einem gemütlichen Ausschlafen setzten wir unsere Reise weiter Richtung Norden fort.
                    <br/><br/>
                    Ein besonderes Highlight unterwegs waren die Whaligoe Steps – steinerne Stufen, die sich spektakulär
                    an der Klippe entlang bis hinunter in eine kleine Bucht winden. Früher nutzten Fischer diesen steilen
                    Weg, um ihren Fang in Körben nach oben zu tragen. In der benachbarten Bucht befindet sich ein Wasserfall,
                    den man von einem Aussichtspunkt an der Klippenkante aus bewundern kann.
                    <br/><br/>
                    Anschließend führte uns unsere Route vorbei an beeindruckenden Klippen und traumhaften Stränden bis
                    an den nordöstlichsten Punkt des britischen Festlands: John o’ Groats. Von dort ging es weiter zum
                    nördlichsten Punkt unserer Reise – Dunnet Head.
                    <br/><br/>
                    Entlang wunderschöner Buchten fuhren wir ein gutes Stück an der Nordküste entlang. Den ersten Übeernachtungsplatz,
                    den wir ansteuerten, mussten wir wegen fehlendem Empfang leider wieder verlassen – schließlich
                    wollen wir euch unseren Blog nicht vorenthalten. Nach einem Tankstopp zeigte sich bei Sven erste
                    anzeichen einer Migräne, weshalb wir uns entschieden haben, für die Nacht noch einmal einen Campingplatz aufzusuchen.
                    <br/><br/>
                    Auch heute gibt es natürlich wieder ein Relive-Video unserer Route:
                    <a href="https://www.relive.com/view/vXOnAWX2D5v"> zur Videoroute</a>
                    <br/><br/>
                    Morgen geht’s weiter entlang der wunderschönen Landschaft der NC500 – bleibt gespannt!
                    <br/><br/>
                    Und damit wünschen wir einen schönen Abend,<br/>
                    Eure BeachBesucher
                </>
            ),
            images: [
                "/images/09_Schottland/4.1.jpeg",
                "/images/09_Schottland/4.2.jpeg",
                "/images/09_Schottland/4.3.jpg",
                "/images/09_Schottland/4.4.jpg",
                "/images/09_Schottland/4.5.jpeg",
                "/images/09_Schottland/4.6.jpeg",
                "/images/09_Schottland/4.7.jpeg",
                "/images/09_Schottland/4.8.jpeg",
                "/images/09_Schottland/4.9.jpg",
                "/images/09_Schottland/4.10.jpg",
                "/images/09_Schottland/4.11.jpeg",
                "/images/09_Schottland/4.12.jpeg",
                "/images/09_Schottland/4.13.jpeg",
                "/images/09_Schottland/4.14.jpeg",
                "/images/09_Schottland/4.15.jpg",
            ]
        },
        {
            date: "21.06.2025",
            title: "3. Tag",
            content: (
                <>
                    Halò
                    <br/><br/>
                    Nach dem Aufstehen setzten wir unsere Fahrt entlang der Snow Road durch den Cairngorms Nationalpark fort.
                    Anschließend ging es weiter in Richtung Inverness.
                    <br/><br/>
                    Ein kurzer Abstecher führte uns direkt zum berühmten Loch Ness – leider blieb uns ein Treffen mit
                    Nessi verwehrt, sie hat sich nicht blicken lassen.
                    <br/><br/>
                    Nach der erfolglosen Suche nach dem Seeungeheuer machten wir uns auf den Weg zur North Coast 500,
                    der Küstenstraße, die wir in den kommenden Tagen erkunden werden.
                    <br/>Unterwegs gönnten wir uns in der traditionsreichen Gelateria Capaldi, eine der ältesten
                    Eisdielen Schottlands, ein super leckeres Glace.
                    <br/><br/>
                    Jetzt stehen wir direkt an der Küste auf einem einfachen Campingplatz, auf dem
                    die Platzgebühr noch ganz klassisch persönlich am Fahrzeug kassiert wird.
                    <br/><br/>
                    Auch heute gibt es wieder ein Relive-Video unserer Route:
                    <a href="https://www.relive.com/view/v7O9ZEy7dQ6"> zur Videoroute</a>
                    <br/><br/>
                    Morgen geht es für uns weiter entlang der NC500 – und wenn alles nach Plan läuft, erreichen wir
                    bereits den nördlichsten Punkt unserer Reise.
                    <br/><br/>
                    Bis morgen,<br/>
                    Eure NessiSucher
                </>
            ),
            images: [
                "/images/09_Schottland/3.1.jpeg",
                "/images/09_Schottland/3.2.jpeg",
                "/images/09_Schottland/3.3.jpg",
                "/images/09_Schottland/3.4.jpg",
                "/images/09_Schottland/3.5.jpg",
                "/images/09_Schottland/3.6.jpg",
            ]
        },
        {
            date: "20.06.2025",
            title: "2. Tag",
            content: (
                <>
                    Guten Abend und hallo aus Schottland
                    <br/><br/>
                    Nach einer erholsamen Nacht auf der Fähre von Amsterdam nach Newcastle konnten wir bereits um 09:20
                    Uhr englischen Boden betreten. Nach dem Passieren des Zolls – inklusive einer kurzen Kontrolle
                    unserer deklarationspflichtigen Waren, die wir glücklicherweise trotzdem mitnehmen
                    durften – ging es direkt weiter in Richtung Edinburgh: Mission Hard Rock Cafe T-Shirt.
                    <br/><br/>
                    Nach einer kurzen Eingewöhnung an den Linksverkehr mit einem rechtsgesteuerten Fahrzeug verlief die Fahrt erstaunlich gut.
                    <br/><br/>
                    Inzwischen haben wir einen schönen Stellplatz im Cairngorms Nationalpark gefunden und lassen den Abend hier ausklingen.
                    <br/><br/>
                    Inspiriert vom Blog meines Vaters haben wir heute ebenfalls ein Relive-Video unserer Route erstellt:
                    <a href="https://www.relive.com/view/vxOQ52wzyMO">zur Videoroute</a>
                    <br/><br/>
                    Morgen dann mehr von Schottland und von unserer Reise.
                    <br/>
                    Eure HardRockCafeSucher
                </>
            ),
            images: [
                "/images/09_Schottland/2.1.jpg",
                "/images/09_Schottland/2.2.jpeg",
                "/images/09_Schottland/2.3.jpeg",
                "/images/09_Schottland/2.4.jpeg",
                "/images/09_Schottland/2.5.jpg",
                "/images/09_Schottland/2.6.jpg",
                "/images/09_Schottland/2.7.jpg",
            ]
        },
        {
            date: "19.06.2025",
            title: "1. Tag",
            content: (
                <>
                    Herzlich Willkommen zu einer neuen Reise mit uns,
                    <br/><br/>
                    Gestern sind wir von Zuhause aufgebrochen, um bereits ein Stück in Richtung Norden zurückzulegen.
                    Die Nacht haben wir in der Nähe von Hockenheim verbracht, sodass wir heute Morgen ausgeruht weiterfahren konnten.
                    <br/><br/>
                    Inzwischen haben wir auf der Fähre eingecheckt und nutzen die verbleibende Zeit mit Internetzugang, um diesen Blogeintrag zu schreiben – denn sobald das Schiff um 17:30 Uhr ablegt, sind wir offline.
                    Morgen früh werden wir dann bereits britischen Boden betreten.
                    <br/><br/>
                    Wir melden uns morgen Abend wieder und berichten euch von unseren ersten Eindrücken aus Schottland.
                    <br/><br/>
                    Bis dahin einen schönen Abend
                    <br/>
                    Eure Fährfahrer
                </>
            ),
            images: [
                "/images/09_Schottland/1.1.jpeg",
                "/images/09_Schottland/1.2.jpeg",
                "/images/09_Schottland/1.3.jpeg",
            ]
        },
    ];
    return (
        <div className="container my-5">
            <div>
                <h2 className="Blog_Title">Schottland</h2>
            </div>
            {blogPosts.map((post, index) => (
                <BlogPostContainer
                    index={index}
                    title={post.title}
                    date={post.date}
                    content={post.content}
                    images={post.images}
                />
            ))}
        </div>
    );
}
export default Schottland;